
<template>

    <div style="display:inline-block" :nullable="nullable" :title="title" :value="FilePathList" ControlType="MultiFileUpload"
         class="MultiFileUpload"
     >

        <div class="FilePathList">
            <div v-for="filePath in FilePathList" class="FilePathContainer">
                <a :href="$util.PrefixUrl(filePath)" target="_blank"
                   v-show="ShowLink!='false'"
                   v-if="filePath != null && filePath != ''"
                   class="FilePath DragHandle"
                   ContainerSelector=".FilePathList"
                   ElementSelector=".FilePathContainer"
                   @mousemove="OnDragHandleMouseMove($event,FilePathList)"
                   :title="filePath"
                   style="margin-right:10px;display:inline-block;color:black">
                    <template v-if="m_ShowFileName">
                        <template v-if="ShowPath=='false'">
                            {{GetFileName(filePath)}}
                        </template>
                        <template v-else>
                            {{filePath}}
                        </template>

                    </template>
                    <template v-else>
                        檢視
                    </template>
                </a> 
                <div class="RemoveButton"
                     v-if="disabled != true && disabled != 'true' && disabled != 1"
                     @click="OnRemoveButtonClick(filePath)">x</div>
            </div>
        </div>
        

        

     
        <t-pictureupload :text="ButtonText"
                         v-if="disabled != true && disabled != 'true' && disabled != 1"
                         style="display:inline-block;"
                         :key="Key"
                         KeepBaseName="true"
                         multiple="true"
                         @ItemsCreate="OnUploadStart"
                         @ItemsComplete="OnUploadComplete"
                         v-model="FilePathList">
        </t-pictureupload>

    </div>



</template>

<script scoped>
    import Utility from '@/Common/Utility'
    import FieldOptionService from '@/Common/FieldOptionService'
    import TControlBase from '@/Common/TControlBase';
    import ChildDraggableBase from '@/Common/ChildDraggableBase'

    export default {
        name: "t-multifileupload",
        data() {
            return {

                Key: 1,

                FilePathList: [],

                ButtonText: "上傳",
                m_ShowFileName:false,
                m_Attribute: {
                    Options: [],
                    OptionName: "",
                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false,
                    DataType: "string"
                }
            }
        }
        ,

        //Only title,CheckUploadHandler,Text,ShowFileName,ShowPath,ShowLink
        props: ["value", "title", "nullable", "Name", "Attribute", "Keep", "KeyName", "CheckUploadHandler", "disabled", "Text","ShowFileName","ShowPath","ShowLink"],


        computed: {

            Nullable: {
                get() {
                    return this.m_Attribute.Nullable;
                }
            }
        }
        ,

        methods: {

            OnRemoveButtonClick(filePath) {
                Utility.RemoveArrayElement(this.FilePathList, filePath);


                this.$emit("change", this.FilePathList);
                this.$emit("input", this.FilePathList);

                this.$forceUpdate();
            },

            GetFileName(filePath) {
                let fileName = "";
                let regex = /\//ig;
                let tokens;


                if (filePath != null && filePath != "") {
                    tokens = filePath.split(regex);

                    fileName = tokens[tokens.length - 1];
                }

                return fileName;

            },

            OnUploadStart(toUploadItems) {
                let tokens;
                let task;
                let validFileName = true;
                let i;


                for (i = 0; i < toUploadItems.length; i++) {
                    if (this.CheckUploadHandler != null) {
                        if (!this.CheckUploadHandler(toUploadItems[i].Task.FileName)) {
                            validFileName = false;
                            break;
                        }
                    }
                }

                return validFileName;
            },



            OnUploadComplete(items) {
                let filePaths = [];
                let result;
                let i;


                Utility.HideLoadingPicture();
 
                
                for (i = 0; i < items.length; i++) {
                    filePaths.push(items[i].PicturePath)

                    this.FilePathList.push(items[i].PicturePath);
                }

                

                //this.FilePath = filePaths.join(",");

                this.$emit("change", this.FilePathList);
                this.$emit("input", this.FilePathList);

                this.$forceUpdate();
            },


            UpdateElementByAttribute() {

            },
 
        },

        mounted() {
    
        },

        beforeMounted() {

        },

        mounted() {
            if (this.Keep == "true" || this.Keep == true) {
                this.LoadValue();
            }
        } ,

        created() {
            TControlBase.call(this);
            ChildDraggableBase.call(this);
            //if (this.value != null) {
            //    this.FilePath = this.value;
            //}


            if (this.Text != null) {
                this.m_Text = this.Text;
            }

            if (this.ShowFileName == true || this.ShowFileName == "true") {
                this.m_ShowFileName = true;
            }

            if (this.value != null) {
                this.FilePathList = this.value;
            }
        },

        watch: {
            value: function (newVal, oldVal) {

                //this.FilePath = newVal;

                if (newVal != null) {
                    this.FilePathList = newVal;
                }
                else {
                    this.FilePathList = [];
                }
            },

            nullable: function (newVal) {
                this.m_Attribute.Nullable = newVal;
            } ,

 
 

        }


    }
</script>

<style scoped>

    /deep/ .ButtonContainer.PictureUpload > span.Button {
        line-height: 36px;
        padding-top: 0px;
    }

    /deep/ .ButtonContainer.PictureUpload input.file {
        line-height: 36px;
    }

    .FilePathContainer {
        display: flex;
        flex-direction: row; 
 
    }

 

        .FilePathContainer  > a {
            white-space:nowrap;
        }
        
        .FilePathContainer .RemoveButton {
            flex-basis: 20px;
            display: inline-block;
            cursor: pointer;
            text-align: center;
            font-size: 18px;
            color: black;
        }

    /deep/ .ButtonContainer.PictureUpload > span.Button {
        line-height: 40px;
    }
</style>
